import { InvalidArgumentError as f } from "./contact-channels135.js";
import y from "./contact-channels123.js";
import { isoWeekdayToLocal as h, dayOfWeek as w } from "./contact-channels133.js";
function c(e) {
  return typeof e > "u";
}
function T(e) {
  return typeof e == "number";
}
function I(e) {
  return typeof e == "number" && e % 1 === 0;
}
function L(e) {
  return typeof e == "string";
}
function A(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function v() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function C() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function F(e) {
  return Array.isArray(e) ? e : [e];
}
function W(e, n, r) {
  if (e.length !== 0)
    return e.reduce((t, o) => {
      const u = [n(o), o];
      return t && r(t[0], u[0]) === t[0] ? t : u;
    }, null)[1];
}
function M(e, n) {
  return n.reduce((r, t) => (r[t] = e[t], r), {});
}
function O(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}
function Y(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new f("Week settings must be an object");
  if (!a(e.firstDay, 1, 7) || !a(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((n) => !a(n, 1, 7)))
    throw new f("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function a(e, n, r) {
  return I(e) && e >= n && e <= r;
}
function $(e, n) {
  return e - n * Math.floor(e / n);
}
function i(e, n = 2) {
  const r = e < 0;
  let t;
  return r ? t = "-" + ("" + -e).padStart(n, "0") : t = ("" + e).padStart(n, "0"), t;
}
function R(e) {
  if (!(c(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function z(e) {
  if (!(c(e) || e === null || e === ""))
    return parseFloat(e);
}
function E(e) {
  if (!(c(e) || e === null || e === "")) {
    const n = parseFloat("0." + e) * 1e3;
    return Math.floor(n);
  }
}
function P(e, n, r = "round") {
  const t = 10 ** n;
  switch (r) {
    case "expand":
      return e > 0 ? Math.ceil(e * t) / t : Math.floor(e * t) / t;
    case "trunc":
      return Math.trunc(e * t) / t;
    case "round":
      return Math.round(e * t) / t;
    case "floor":
      return Math.floor(e * t) / t;
    case "ceil":
      return Math.ceil(e * t) / t;
    default:
      throw new RangeError(`Value rounding ${r} is out of range`);
  }
}
function d(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function k(e) {
  return d(e) ? 366 : 365;
}
function U(e, n) {
  const r = $(n - 1, 12) + 1, t = e + (n - r) / 12;
  return r === 2 ? d(t) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][r - 1];
}
function V(e) {
  let n = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (n = new Date(n), n.setUTCFullYear(e.year, e.month - 1, e.day)), +n;
}
function s(e, n, r) {
  return -h(w(e, 1, n), r) + n - 1;
}
function B(e, n = 4, r = 1) {
  const t = s(e, n, r), o = s(e + 1, n, r);
  return (k(e) - t + o) / 7;
}
function Z(e) {
  return e > 99 ? e : e > y.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function x(e, n, r, t = null) {
  const o = new Date(e), u = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  t && (u.timeZone = t);
  const m = { timeZoneName: n, ...u }, l = new Intl.DateTimeFormat(r, m).formatToParts(o).find((p) => p.type.toLowerCase() === "timezonename");
  return l ? l.value : null;
}
function H(e, n) {
  let r = parseInt(e, 10);
  Number.isNaN(r) && (r = 0);
  const t = parseInt(n, 10) || 0, o = r < 0 || Object.is(r, -0) ? -t : t;
  return r * 60 + o;
}
function D(e) {
  const n = Number(e);
  if (typeof e == "boolean" || e === "" || !Number.isFinite(n))
    throw new f(`Invalid unit value ${e}`);
  return n;
}
function b(e, n) {
  const r = {};
  for (const t in e)
    if (O(e, t)) {
      const o = e[t];
      if (o == null) continue;
      r[n(t)] = D(o);
    }
  return r;
}
function q(e, n) {
  const r = Math.trunc(Math.abs(e / 60)), t = Math.trunc(Math.abs(e % 60)), o = e >= 0 ? "+" : "-";
  switch (n) {
    case "short":
      return `${o}${i(r, 2)}:${i(t, 2)}`;
    case "narrow":
      return `${o}${r}${t > 0 ? `:${t}` : ""}`;
    case "techie":
      return `${o}${i(r, 2)}${i(t, 2)}`;
    default:
      throw new RangeError(`Value format ${n} is out of range for property format`);
  }
}
function G(e) {
  return M(e, ["hour", "minute", "second", "millisecond"]);
}
export {
  D as asNumber,
  W as bestBy,
  U as daysInMonth,
  k as daysInYear,
  $ as floorMod,
  q as formatOffset,
  C as hasLocaleWeekInfo,
  O as hasOwnProperty,
  v as hasRelative,
  a as integerBetween,
  A as isDate,
  I as isInteger,
  d as isLeapYear,
  T as isNumber,
  L as isString,
  c as isUndefined,
  F as maybeArray,
  b as normalizeObject,
  V as objToLocalTS,
  i as padStart,
  z as parseFloating,
  R as parseInteger,
  E as parseMillis,
  x as parseZoneInfo,
  M as pick,
  P as roundTo,
  H as signedOffset,
  G as timeObject,
  Z as untruncateYear,
  Y as validateWeekSettings,
  B as weeksInWeekYear
};
//# sourceMappingURL=contact-channels128.js.map
